import { render, staticRenderFns } from "./AssureTable.vue?vue&type=template&id=5f58d7ce&scoped=true"
import script from "./AssureTable.vue?vue&type=script&lang=js"
export * from "./AssureTable.vue?vue&type=script&lang=js"
import style0 from "./AssureTable.vue?vue&type=style&index=0&id=5f58d7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58d7ce",
  null
  
)

export default component.exports